import { styled } from '@mui/material';
import { NavLink } from 'react-router-dom';

import { ReactComponent as ArrowDown } from 'assets/icons/arrowRight.svg';

export const ListW = styled('div')`
  display: flex;
  padding-top: 12px;

  @media (max-width: 1023px) {
    flex-direction: column;
    padding-top: 0;
    width: 100%;
  }
`;

export const ArrowRight = styled(ArrowDown)`
  cursor: pointer;
  margin-left: 17px;
  margin-top: 40px;
`;

export const ArrowLeft = styled(ArrowDown)`
  transform: rotate(-180deg);
  cursor: pointer;
  margin-right: 17px;
  margin-top: 40px;
`;

export const PreviewW = styled('div')`
  position: relative;
  display: flex;
`;

export const ArrowW = styled('div')`
  margin-left: auto;
`;

export const Wrapper = styled('div')<{ showRightArrow: boolean; showLeftArrow: boolean }>`
  width: 100%;
  display: flex;
  justify-content: ${({ showRightArrow, showLeftArrow }) =>
    showRightArrow && showLeftArrow
      ? 'center'
      : !showRightArrow && showLeftArrow
      ? 'flex-start'
      : ''};
`;

export const SeeAllLink = styled(NavLink)`
  display: block;
  text-align: right;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.p080};
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    opacity: 0.7;
  }
`;

export const InnerContainer = styled('div')`
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  background-color: ${({ theme }) => theme.palette.white.main};
  margin-top: 40px;
  border-radius: 8px;
  width: 100%;
  height: 100%;
  padding: 16px;

  @media (max-width: 1023px) {
    margin-top: 16px;
  }
`;
